import apiClient from '../../../services/apiClient';

/**
 * Lair (DNA + coin farms worked by heroes, v1.47.0) + Missions API.
 * Contract: .claude/lair-feature/SPEC.md (v1.39.0) + LAIR_V147.md.
 */
export const lairAPI = {
  // GET /v1/lair → LairStateDTO
  getLair: async () => {
    const response = await apiClient.get('/v1/lair');
    return response.data;
  },
  // POST /v1/lair/buildings/{buildingId}/unlock → LairStateDTO (coins + DNA, v1.47.0)
  unlockBuilding: async (buildingId) => {
    const response = await apiClient.post(`/v1/lair/buildings/${buildingId}/unlock`);
    return response.data;
  },
  // PUT /v1/lair/buildings/{buildingId}/hero { characterId } → LairStateDTO
  assignHero: async (buildingId, characterId) => {
    const response = await apiClient.put(`/v1/lair/buildings/${buildingId}/hero`, { characterId });
    return response.data;
  },
  // DELETE /v1/lair/buildings/{buildingId}/hero → LairStateDTO
  removeHero: async (buildingId) => {
    const response = await apiClient.delete(`/v1/lair/buildings/${buildingId}/hero`);
    return response.data;
  },
  // POST /v1/lair/buildings/{buildingId}/claim → { collected, state: LairStateDTO }
  claimFarm: async (buildingId) => {
    const response = await apiClient.post(`/v1/lair/buildings/${buildingId}/claim`);
    return response.data;
  },
};

export const missionsAPI = {
  // GET /v1/missions → { serverTime, bonuses, missions, runs, characters }
  getMissions: async () => {
    const response = await apiClient.get('/v1/missions');
    return response.data;
  },
  // POST /v1/missions/{missionId}/start { characterId } → MissionRunDTO
  startMission: async (missionId, characterId) => {
    const response = await apiClient.post(`/v1/missions/${missionId}/start`, { characterId });
    return response.data;
  },
  // POST /v1/missions/runs/{runId}/claim → MissionRunDTO (with success + rewards)
  claimMissionRun: async (runId) => {
    const response = await apiClient.post(`/v1/missions/runs/${runId}/claim`);
    return response.data;
  },
};

export const getLair = lairAPI.getLair;
export const getMissions = missionsAPI.getMissions;
export const startMission = missionsAPI.startMission;
export const claimMissionRun = missionsAPI.claimMissionRun;
